<template>
    <div class="authentication-company-master-container">
        <div v-show="!isDetail || reEdit">
            <el-form ref="form" :model="formData" :rules="formRules" size="small">
                <div class="info-tt">
                    企业信息
                </div>
                <el-form-item>
                    <el-form-item label="企业名称" prop="companyName" class="required">
                        <el-input v-model="formData.companyName" placeholder="请输入" maxlength="200"></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用代码" prop="companyCode" class="required">
                        <el-input v-model="formData.companyCode" placeholder="请输入" maxlength="18"></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="法定代表人" prop="legalPerson" class="required">
                        <el-input v-model="formData.legalPerson" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="法定代表人身份证号" prop="legalPersonIdcard" class="required">
                        <el-input v-model="formData.legalPersonIdcard" placeholder="请输入" maxlength="18"></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="营业执照" required prop="companyBusinessLicense" class="required">
                        <image-upload :cliengguid="rowguid" :clienttag="['yyzz']"
                                      :data="formData.companyBusinessLicense"
                                      :key="formData.companyBusinessLicense.length"
                                      @change="handleCompanyBusinessLicense"></image-upload>
                    </el-form-item>
                    <el-form-item label="法定代表人身份证(正反面)" required prop="legalPersonIdcardImages"
                                  class="required">
                        <image-upload :limit="2" :cliengguid="rowguid" :clienttag="['idcard1', 'idcard2']"
                                      :data="formData.legalPersonIdcardImages"
                                      :key="formData.legalPersonIdcardImages.length"
                                      @change="handleLegalPersonIdcardImages"></image-upload>
                    </el-form-item>
                </el-form-item>
                <div class="info-tt">
                    店铺信息
                </div>
                <el-form-item>
                    <el-form-item label="店铺名称" prop="shopName" class="required">
                        <el-input v-model="formData.shopName" type="textarea" maxlength="20" rows="6"
                                  placeholder="请输入4-20个字符，允许用中英文，数字和下划线" show-word-limit
                                  :resize="'none'"></el-input>
                    </el-form-item>
                    <el-form-item label="店铺介绍" prop="shopIntroduce" class="required">
                        <el-input v-model="formData.shopIntroduce" type="textarea" maxlength="120" rows="6"
                                  placeholder="请输入18-120字,简明扼要的介绍您自己，让用户了解您的服务和内容"
                                  show-word-limit
                                  :resize="'none'"></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="店铺头像" required prop="shopAvatar" class="required">
                        <p class="tip">
                            头像尺寸180*180，jpg/png格式，1M以内
                        </p>
                        <image-upload :size="1024 * 1024 * 1" :type="['.jpg', '.png']" :cliengguid="rowguid"
                                      :clienttag="['shoppic']" :data="formData.shopAvatar"
                                      :dimension="[180,180]"
                                      :key="formData.shopAvatar.length"
                                      @change="handleShopAvatar"></image-upload>
                    </el-form-item>
                    <el-form-item label="合同签署" prop="signedcontractguid" class="required">
                        <p class="tip">
                            签署前，需要使用标证通申请企业移动证书
                        </p>
                        <div class="contract-list">
                            <div class="contract-item">
                                <div class="contract-info">
                                    <div class="contract-name">
                                        合同
                                    </div>
                                    <label v-if="isSignContract">
                                        已签署
                                    </label>
                                </div>
                                <a href="javascript:" v-if="isSignContract" @click="previewContract()">预览</a>
                                <a href="javascript:" class="highlight" @click="signContract()">
                                    {{ isSignContract ? '重新签署' : '去签署' }}
                                </a>
                            </div>
                        </div>
                        <div class="attach-list">
                            <div class="attach-item" v-for="(item, index) in attachs" :key="index">
                                <div class="attach-name">
                                    <span> {{ item.name }}</span>
                                    <i class="el-icon-download" @click="downloadAttach(item.downloadUrl)"></i>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>
            </el-form>
            <div class="footer">
                <div class="agree">
                    <el-checkbox v-model="agree"></el-checkbox>
                    我已同意
                    <span v-for="(item, index) in agreementDialog.data" class="agreement-item" :key="index"
                          @click="openAgreementDialog(index)">
                        <a href="javascript:;">{{ item.title }}</a>
                        <span>和</span>
                    </span>
                    <!-- <span @click="openAgreementDialog">《免责协议》</span> 和
                    <span @click="openAgreementDialog">《授权书》</span> -->
                </div>
                <div class="footer-btns">
                    <el-button type="primary" size="small" @click="submit">
                        提交审核
                    </el-button>
                    <el-button size="small" @click="closeDialog">
                        取消
                    </el-button>
                </div>
            </div>
        </div>
        <div v-show="!(!isDetail || reEdit)">
            <div class="state state1" v-if="formData.reviewState == 1">
                <div class="state-text">
                    审核中
                </div>
            </div>
            <div class="state state2" v-if="formData.reviewState == 3">
                <div class="state-text">
                    审核不通过
                    <span>
                        您可以重新提交认证申请
                    </span>
                    <span class="date"> 审核时间：{{ formData.reviewDate }} </span>
                </div>
                <p>
                    {{ formData.reviewReason }}
                </p>
            </div>
            <el-form size="small">
                <div class="info-tt">
                    企业信息
                </div>
                <el-form-item>
                    <el-form-item label="企业名称" class="required">
                        {{ formData.companyName }}
                    </el-form-item>
                    <el-form-item label="统一社会信用代码" class="required">
                        {{ formData.companyCode }}
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="法定代表人" class="required">
                        {{ formData.legalPerson }}
                    </el-form-item>
                    <el-form-item label="法定代表人身份证号" class="required">
                        {{ formData.legalPersonIdcard }}
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="营业执照" class="required">
                        <div class="image-list">
                            <div class="image-item" v-for="(item, index) in formData.companyBusinessLicense"
                                 :key="index + '-' + item">
                                <el-image
                                    ref="image"
                                    style="width: 100%; height: 100%"
                                    :src="item.previewurl"
                                    :preview-src-list="[item.previewurl]">
                                </el-image>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="法定代表人身份证(正反面)" class="required">
                        <div class="image-list">
                            <div class="image-item" v-for="(item, index) in formData.legalPersonIdcardImages"
                                 :key="index + '-' + item">
                                <el-image
                                    ref="image"
                                    style="width: 100%; height: 100%"
                                    :src="item.previewurl"
                                    :preview-src-list="[item.previewurl]">
                                </el-image>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>
                <div class="info-tt">
                    店铺信息
                </div>
                <el-form-item>
                    <el-form-item label="店铺名称" class="required">
                        {{ formData.shopName }}
                    </el-form-item>
                    <el-form-item label="店铺介绍" class="required">
                        {{ formData.shopIntroduce }}
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="店铺头像" class="required">
                        <div class="image-list">
                            <div class="image-item" v-for="(item, index) in formData.shopAvatar"
                                 :key="index + '-' + item">
                                <el-image
                                    ref="image"
                                    style="width: 100%; height: 100%"
                                    :src="item.previewurl"
                                    :preview-src-list="[item.previewurl]">
                                </el-image>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同签署" class="required">
                        <div class="contract-list">
                            <div class="contract-item" >
                                <div class="contract-info">
                                    <div class="contract-name">
                                        合同
                                    </div>
                                </div>
                                <a href="javascript:" class="highlight" @click="previewContract()">预览</a>
                            </div>
                        </div>
                        <div class="attach-list">
                            <div class="attach-item" v-for="item in attachs" :key="item.guid">
                                <div class="attach-name">
                                    <span> {{ item.name }}</span>
                                    <i class="el-icon-download" @click="downloadAttach(item.downloadUrl)"></i>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form-item>
            </el-form>
            <div class="footer" v-if="formData.reviewState == 3">
                <div class="footer-btns">
                    <el-button type="primary" size="small" @click="rewrite">
                        重新编辑
                    </el-button>
                    <el-button size="small" @click="closeDialog">
                        取消
                    </el-button>
                </div>
            </div>
        </div>
        <el-dialog :title="contractDialog.title" width="100%" custom-class="contract-dialog"
                   @close="closeContractDialog" :visible.sync="contractDialog.show" append-to-body
                   :close-on-press-escape="false"
                   :close-on-click-modal="false" destroy-on-close>
            <iframe :src="contractDialog.url"></iframe>
        </el-dialog>

        <el-dialog :title="agreementDialog.title" :width="agreementDialog.width" custom-class="agreement-dialog"
                   :visible.sync="agreementDialog.show" append-to-body :close-on-press-escape="false"
                   :close-on-click-modal="false" destroy-on-close>
            <template #title>
                <div class="agreement-dialog-titles" :class="{
                    'tab-style': agreementDialog.data.length > 1
                }">
                    <div class="agreement-dialog-title" v-for="(item, index) in agreementDialog.data"
                         :class="{ active: index === agreementDialog.activeTab }"
                         @click="agreementDialog.activeTab = index" :key="index">
                        {{ item.title }}
                    </div>
                </div>
            </template>
            <div class="agreement-dialog-inner" :style="{ height: agreementDialog.height }">
                <iframe v-for="(item, index) in agreementDialog.data" v-show="index === agreementDialog.activeTab"
                        :key="index" :src="item.url" frameborder="0"></iframe>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import ImageUpload from './image-upload.vue';
import {createGuid, downloadAttach} from '@/util/util';

export default {
    name: 'AuthenticationCompanyMasterDialog',
    components: {
        ImageUpload
    },
    props: {
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: null,
            rowguid: '',
            formData: {
                companyName: '',
                companyCode: '',
                legalPerson: '',
                legalPersonIdcard: '',
                companyBusinessLicense: [],
                legalPersonIdcardImages: [],
                shopName: '',
                shopIntroduce: '',
                shopAvatar: [],
                signedcontractguid: ''
            },
            formRules: {
                companyName: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                companyCode: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                legalPerson: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                legalPersonIdcard: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                companyBusinessLicense: [
                    {
                        required: true,
                        message: '请上传',
                        trigger: 'change'
                    }
                ],
                legalPersonIdcardImages: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请上传'));
                                return;
                            } else if (value.length < 2) {
                                callback(new Error('请上传身份证正面与反面'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'change'
                    }
                ],
                shopName: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('请输入'));
                                return;
                            }

                            // 检查是否只包含中文、英文、数字和下划线
                            const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/;
                            if (!regex.test(value)) {
                                callback(new Error('只允许使用中文、英文、数字和下划线'));
                                return;
                            }

                            callback();
                        },
                        trigger: 'blur'
                    }
                ],
                shopIntroduce: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                shopAvatar: [
                    {
                        required: true,
                        message: '请上传',
                        trigger: 'change'
                    }
                ],
                signedcontractguid: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value || !this.isSignContract) {
                                callback(new Error('请签署合同'));
                                return;
                            }
                            callback();
                        },
                        trigger: 'change',
                    }
                ]
            },
            attachs: [
                {
                    name: '操作手册',
                    downloadUrl: window.Config.operationManualUrl
                }
            ],
            agree: [],
            isSignContract: false,
            contractDialog: {
                show: false,
                title: '',
                url: '',
                isSign: false
            },
            agreementDialog: {
                show: false,
                width: '850px',
                height: '700px',
                data: [],
                activeTab: 0
            },
            reEdit: false,// 重新编辑
            imagePreviewUrl: ''
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    mounted() {
        this.agreementDialog.data = window.Config.enterpriseCertificationAgreementUrl;
        this.rowguid = createGuid();
        this.form = this.$refs.form;
        if (this.isDetail) {
            this.getMasterInfo();
        }
        window.addEventListener('message', this.handleIframeMessage);
    },
    beforeDestroy() {
        // 组件销毁时移除监听
        window.removeEventListener('message', this.handleIframeMessage);
    },
    methods: {
        getMasterInfo() {
            this.$Api
                .getMasterInfo({
                    userguid: this.userInfo.userguid,
                    shopguid: '',
                    ishomepage: '0'
                })
                .then((data) => {
                    this.rowguid = data.publisher.rowguid;
                    this.formData.reviewState = data.publisher.reviewState;
                    // 新增审核不通过
                    this.formData.reviewDate = data.publisher.reviewDate;
                    this.formData.reviewReason = data.publisher.reviewReason;

                    this.formData.companyName = data.enterprise.enterprisename;
                    this.formData.companyCode = data.enterprise.unitorgnum;
                    this.formData.legalPerson = data.enterprise.faren;
                    this.formData.legalPersonIdcard = data.enterprise.farenidcard;
                    this.formData.companyBusinessLicense = [
                        {
                            previewurl: data.enterprise.busilicenseattach,
                            attachguid: data.enterprise.busilicenseattachguid
                        }
                    ];
                    this.formData.legalPersonIdcardImages = [
                        {
                            previewurl: data.enterprise.farenidcard1attach,
                            attachguid: data.enterprise.farenidcard1attachguid
                        },
                        {
                            previewurl: data.enterprise.farenidcard1attach2,
                            attachguid: data.enterprise.farenidcard1attachguid2
                        }
                    ];
                    this.formData.shopName = data.shop.shopname;
                    this.formData.shopIntroduce = data.shop.introduce;
                    this.formData.shopAvatar = [
                        {
                            previewurl: data.shop.profilepicattach,
                            attachguid: data.shop.profilepicattachguid
                        }
                    ];
                    this.formData.signedcontractguid = data.shop.signedcontractguid;
                });
        },
        handleCompanyBusinessLicense(data) {
            this.formData.companyBusinessLicense = data;
            this.$nextTick(() => {
                this.form.validateField('companyBusinessLicense');
            })
        },
        handleLegalPersonIdcardImages(data) {
            this.formData.legalPersonIdcardImages = data;
            this.$nextTick(() => {
                this.form.validateField('legalPersonIdcardImages');
            })
        },
        handleShopAvatar(data) {
            this.formData.shopAvatar = data;
            this.$nextTick(() => {
                this.form.validateField('shopAvatar');
            })
        },
        submit() {
            this.form = this.$refs.form;
            this.form.validate((valid) => {
                if (valid) {
                    let submitData = {
                        enterprise: {
                            rowguid: this.rowguid,
                            enterprisename: this.formData.companyName,
                            unitorgnum: this.formData.companyCode,
                            faren: this.formData.legalPerson,
                            farenidcard: this.formData.legalPersonIdcard,
                            busilicenseattach: this.formData.companyBusinessLicense[0].attachguid,
                            farenidcard1attach: this.formData.legalPersonIdcardImages[0].attachguid,
                            farenidcard1attach2: this.formData.legalPersonIdcardImages[1].attachguid
                        },
                        shop: {
                            rowguid: this.rowguid,
                            shopname: this.formData.shopName,
                            introduce: this.formData.shopIntroduce,
                            profilepicattach: this.formData.shopAvatar[0].attachguid,
                            signedcontractattach: this.formData.signedcontractguid
                        }
                    };
                    if (!this.agree.length) {
                        let tipText = ''
                        this.agreementDialog.data.forEach(item => {
                            tipText += item.title + '和'
                        })
                        tipText = tipText.slice(0, -1)
                        this.$message.error('请同意' + tipText);
                        return;
                    }
                    if (this.formData.shopName.length < 4) {
                        this.$message.error('店铺名称不能少于4个字');
                        return;
                    }
                    if (this.formData.shopIntroduce.length < 18) {
                        this.$message.error('店铺介绍不能少于18个字');
                        return;
                    }
                    this.$Api
                        .submitAuthofEnterprise(
                            {
                                userguid: this.userInfo.userguid,
                                ...submitData
                            },
                            {
                                showLoading: true
                            }
                        )
                        .then((data) => {
                            this.$message({
                                type: data.state,
                                message: data.message
                            });
                            if (data.state == 'success') {
                                this.$emit('closeDialog');
                            }
                        });
                }
            });
        },
        closeDialog() {
            this.$emit('closeDialog');
        },
        previewContract(url) {
            url =
                window.Config.previewContractDialogUrl +
                '?attachguid=' +
                this.formData.signedcontractguid +
                '&ispreview=1&userguid=' +
                this.userInfo.userguid +
                '&rowguid=' +
                this.rowguid;
            this.contractDialog.title = '预览合同';
            this.contractDialog.url = url;
            this.contractDialog.show = true;
        },
        signContract() {
            if (!this.formData.companyName) {
                this.form.validateField('companyName')
                this.$message.error('请填写企业名称');
                return false;
            }
            if(this.isSignContract){
                this.$confirm('重新签署会删除之前已签章的数据，是否继续？','提示',{
                    type:'warning'
                }).then(()=>{
                    this.isSignContract = false;
                    this.formData.signedcontractguid = '';
                    this.form.validateField('signedcontractguid')
                    this.createContract();
                })
            }else {
                this.createContract();
            }
        },
        createContract(){
            this.$Api.generatecontractpdf({
                companyname: this.formData.companyName,
                cliengguid: this.rowguid,
                clienttag: "unsignedcontract",
                userguid: this.userInfo.userguid
            }, {
                showLoading: true
            }).then(data => {
                if (data.status === 'success') {
                    this.formData.signedcontractguid = data.attachGuid;
                    this.openSignContractDialog();
                } else {
                    this.$message.error(data.message);
                }
            })
        },
        openSignContractDialog() {
            let url =
                window.Config.signContractDialogUrl +
                '?attachguid=' +
                this.formData.signedcontractguid +
                '&ispreview=0&userguid=' +
                this.userInfo.userguid +
                '&rowguid=' +
                this.rowguid;
            this.contractDialog.title = '签署合同';
            this.contractDialog.url = url;
            this.contractDialog.isSign = true;
            this.contractDialog.show = true;
        },
        downloadAttach(url) {
            downloadAttach(url);
        },
        closeContractDialog() {
            if (this.contractDialog.isSign) {
                this.getAuthenticationCompanyMasterContract();
            }
            this.contractDialog.show = false;
            this.contractDialog.title = '';
            this.contractDialog.url = '';
            this.contractDialog.isSign = false;
        },
        getAuthenticationCompanyMasterContract() {
            this.$Api
                .getAuthenticationCompanyMasterContract({
                    cliengguid: this.rowguid,
                    clienttag: 'contract',
                })
                .then((data) => {
                    this.isSignContract = data.issign == 1;
                    this.form.validateField('signedcontractguid')
                });
        },
        handleIframeMessage(event) {
            /**
             *  data{
             *    type: 'CONTRACT_SIGNEDD'
             *    signedcontractattach: ''
             * }
             */
            // 验证来源和消息类型
            if (event.data.type === 'CONTRACT_SIGNEDD') {
                this.formData.signedcontractguid = event.data.signedcontractattach;
                this.closeContractDialog();
                this.getSignedContractState();
            }
        },
        getSignedContractState() {
            this.form.validateField('signedcontractguid');
        },
        openAgreementDialog(tab) {
            this.agreementDialog.activeTab = tab;
            this.agreementDialog.show = true;
        },
        rewrite() {
            this.reEdit = true;
            this.isSignContract = true;
        }
    }
}
</script>
<style lang="scss" scoped>
@import './style/authentication-company-master-dialog.scss';
</style>
